// Import components
import { ErrorMessage } from '../../components/Error';

// Import texts
import errorTexts from '../../texts/error';

// Error page
function Error() {
    return <ErrorMessage critical={true} message={errorTexts.urlNotFound} />;
}

export default Error;
